// extracted by mini-css-extract-plugin
export var FeedbackForm = "feedback-form-module--FeedbackForm--3oAOW";
export var FeedbackForm__title = "feedback-form-module--FeedbackForm__title--116_d";
export var FeedbackForm__row = "feedback-form-module--FeedbackForm__row--khFj1";
export var FeedbackForm__loading = "feedback-form-module--FeedbackForm__loading--2Bp5X";
export var Loading = "feedback-form-module--Loading--1p3nb";
export var FeedbackForm__error = "feedback-form-module--FeedbackForm__error--25-71";